import { User } from '../types';

export const getProfile = (user: User | null) => {
    if (!user) return null;
    return user.role === 'student' ? user.studentProfile : user.tutorProfile;
};

export const getAvatarUrl = (user: User | null) => {
    if (!user) return undefined;
    const profile = getProfile(user);
    if (!profile) return undefined;

    return (
        (profile as any).profileImageUrl ||
        profile.profilePicture ||
        profile.profilePic ||
        profile.image ||
        profile.imageUrl ||
        profile.photoUrl ||
        profile.photoURL ||
        profile.avatar ||
        profile.avatarUrl ||
        user.studentProfile?.profilePicture ||
        user.tutorProfile?.profilePicture ||
        (user.tutorProfile as any)?.profileImageUrl ||
        user.studentProfile?.image ||
        user.tutorProfile?.image ||
        user.studentProfile?.photoUrl ||
        user.tutorProfile?.photoUrl ||
        user.profilePicture ||
        user.profilePic ||
        user.image ||
        user.imageUrl ||
        user.photoUrl ||
        user.photoURL ||
        user.avatar ||
        user.avatarUrl
    );
};
